import React, { Component } from "react";
import { fire, auth } from "../../../firebase/index";
//? English Version
import addRecipient1 from "../../../assets/img/tutorialimages/addRecipientGuide1.png";
import addRecipient2 from "../../../assets/img/tutorialimages/addRecipientGuide2.png";
//? Japanese Version
import addRecipient1Jap from "../../../assets/img/tutorialimages/addRecipientGuide1_Jap.png";
import addRecipient2Jap from "../../../assets/img/tutorialimages/addRecipientGuide2_Jap.png";

class AddRecipientGuide extends Component {
  state = {
    language: "en",
  };

  componentDidMount() {
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            language: snapshot.val(),
          });
        });
    }
  }

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    const { language } = this.state;
    return (
      <div
        style={{
          width: "90%",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        <img
          className="imgStyle"
          src={
            language === "en"
              ? addRecipient1
              : language === "ja"
              ? addRecipient1Jap
              : language === "es"
              ? addRecipient1
              : addRecipient1
          }
          alt="addRecipient1"
          style={{
            width: "100%",
            marginLeft: "auto",
            marginRight: "auto",
            height: "100%",
          }}
        />
        <img
          className="imgStyle"
          src={
            language === "en"
              ? addRecipient2
              : language === "ja"
              ? addRecipient2Jap
              : language === "es"
              ? addRecipient2
              : addRecipient2
          }
          alt="addRecipient2"
          style={{
            width: "100%",
            marginLeft: "auto",
            marginRight: "auto",
            height: "100%",
          }}
        />
      </div>
    );
  }
}

export default AddRecipientGuide;
